export default function () {

	if ( $('.projects__grid').length > 0 ) {

		$(document).on( 'click', '.post-type-archive-project .projects__filter-item a', function(e) {
			$('.projects__filter-item a').removeClass('active');
			$(this).addClass('active');
			e.preventDefault();
			var filterValue = $(this).attr('data-filter');
			location.hash = 'category=' + encodeURIComponent( filterValue );
		});

	}

}


// WEBPACK FOOTER //
// ./scripts/components/SetupProjectsFilters.js